module.exports = __webpack_public_path__ + "static/img/sec3-cont01@m.7b93af5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution/sec3-cont01@m.png
// module id = p5nk
// module chunks = 0